import { createSelector } from 'reselect';
import { defaultState } from '../prescription/state.js';
import { getPrescriptionGlasses, frameSkuProp } from '../selectors.internal.js';

const getConfiguration = createSelector(getPrescriptionGlasses, frameSkuProp, (pg, frameSku)=>pg.configurations[frameSku]
);
const getLensTypeSku = createSelector(getConfiguration, (config)=>{
    var ref1;
    return config === null || config === void 0 ? void 0 : (ref1 = config.lensType) === null || ref1 === void 0 ? void 0 : ref1.sku;
});
const getPackageSku = createSelector(getConfiguration, (config)=>{
    return config === null || config === void 0 ? void 0 : config.package;
});
const getAddOnSku = createSelector(getConfiguration, (config)=>{
    return config === null || config === void 0 ? void 0 : config.addOn;
});
var ref;
const getPrescription = createSelector(getConfiguration, (c)=>{
    var ref2;
    return (ref = c === null || c === void 0 ? void 0 : (ref2 = c.lensType) === null || ref2 === void 0 ? void 0 : ref2.prescriptionInfo) !== null && ref !== void 0 ? ref : defaultState;
});

export { getAddOnSku, getConfiguration, getLensTypeSku, getPackageSku, getPrescription };
//# sourceMappingURL=selectors.internal.js.map
